import { useGlightbox } from "~/lib/glightbox"
import { useSplide } from "~/lib/splide"

document.addEventListener('DOMContentLoaded', () => {
  useSplide('[single-project-splide]')
    .then((splide) => {
      splide?.mount()
    })

  useSplide('[data-single-project-plans]')
    .then((splide) => {
      splide?.mount()
    })

  useGlightbox('.glightbox') 
})